





















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { RoomInterface } from "@/resources/interfaces/roomInterfaces";
import {
  SPACES_POSITIONS,
  SPACES_VALUES,
} from "@/resources/constants/graphicClient/roomsPositions";
import { ROOM_TYPE } from "@/resources/constants/space";
import { SPACES_POSTER_POSITIONS } from "@/resources/constants/graphicClient/posterPositions";
@Component({
  name: "select-room-component",
})
export default class SelectRoomComponent extends Vue {
  MEETING = ROOM_TYPE.MEETING;
  selectorRoom = 0;
  @Prop() roomSelectedId: number;
  @Prop({ default: false }) grazing: boolean;
  @Prop({ default: null }) space;
  @Prop({ default: false }) poster;
  roomSelected: RoomInterface | null = null;
  roomsPositions = null;
  spaceValuesPosition = null;
  countLoadImageNumber = 0;
  mounted(): void {
    let space = this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
    if (!space) space = this.$store.getters["SpaceStore/getSpace"];
    const image = document.getElementById("image-space");
    if (image instanceof HTMLImageElement) {
      image.src = space.scenario.scenarioType.topViewImage.url;
      image.onload = () => {
        this.loadPositions();
      };
      image.onerror = () => {
        if (process.env.VUE_APP_ENVIRONMENT != "PRO")
          console.log("SelectRoomComponent LOAD IMAGEN ERROR");
      };
    }
    window.addEventListener("resize", this.handler);
  }
  get selectId() {
    return this.roomSelectedId;
  }
  set selectId(e) {
    this.selectRoom(e);
  }
  get rooms() {
    let space = this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
    if (!space) space = this.$store.getters["SpaceStore/getSpace"];
    const rooms = !this.poster
      ? space.scenario.rooms.sort(
          (a, b) => a.graphicClientRoomId - b.graphicClientRoomId
        )
      : space?.scenario?.posters.sort(
          (a, b) => a.graphicClientId - b.graphicClientId
        );
    return rooms;
  }
  destroyed() {
    window.removeEventListener("resize", this.handler);
  }
  handler(event) {
    this.setPositions();
  }
  invLerp(from, to, value) {
    return (value - from) / (to - from);
  }
  setPositions() {
    const imageDiv = document.getElementById("selector-image");
    if (imageDiv) {
      const width = imageDiv.offsetWidth;
      const heigth = imageDiv.offsetHeight;

      if (this.roomsPositions == null || this.spaceValuesPosition == null) {
        if (this.countLoadImageNumber < 4) {
          this.countLoadImageNumber++;
          this.loadPositions();
        }
        return;
      }
      const elements = document.getElementsByClassName("roomId");
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0]);
      }
      for (const position in this.roomsPositions) {
        const x =
          this.invLerp(
            this.spaceValuesPosition[0],
            this.spaceValuesPosition[2],
            this.roomsPositions[position].position.x
          ) * width;
        const y =
          this.invLerp(
            this.spaceValuesPosition[1],
            this.spaceValuesPosition[3],
            -this.roomsPositions[position].position.z
          ) * heigth;
        const item = document.createElement("div");
        item.setAttribute("class", "roomId");
        const searchItemRoom = document.getElementById("room-" + position);
        if (searchItemRoom) {
          searchItemRoom.remove();
        }
        item.setAttribute("id", "room-" + position);
        item.style.top = y - 16 + "px";
        item.style.left = x - 12 + "px";
        item.innerText = position;
        item.onclick = () => {
          //this.roomSelectedId = parseInt(position);
          this.selectRoom(parseInt(position));
        };
        imageDiv.appendChild(item);
      }
    }
  }
  /**
   * activa y desactiva la room selecionada
   * */
  @Watch("roomSelectedId")
  activeOrDeactivateRoom() {
    const activeRooms = document.getElementsByClassName("roomId active");

    for (const activeRoom of activeRooms) {
      activeRoom.removeAttribute("class");
      activeRoom.setAttribute("class", "roomId");
    }
    const itemPosition = document.getElementById(
      "room-" + this.roomSelectedId.toString()
    );
    if (itemPosition) itemPosition.setAttribute("class", "roomId active");
  }

  selectRoom(position): void {
    const rooms = this.rooms;
    this.roomSelected = rooms.filter((a) =>
      !this.poster
        ? a.graphicClientRoomId === position
        : a.graphicClientId === position
    )[0];
    //(this.$refs["backgroundImage"] as HTMLInputElement).value = "";
    this.$emit("select-room", { room: this.roomSelected, position });
    //this.activeOrDeactivateRoom();
  }

  loadPositions() {
    let space = this.$store.getters["SpaceStore/getSelectedSpaceCustomize"];
    if (!space) space = this.$store.getters["SpaceStore/getSpace"];
    this.roomsPositions = !this.poster
      ? SPACES_POSITIONS[space?.scenario.scenarioType.name]
      : SPACES_POSTER_POSITIONS[space?.scenario.scenarioType.name];
    this.spaceValuesPosition = SPACES_VALUES[space?.scenario.scenarioType.name];
    setTimeout(() => {
      this.setPositions();
      this.activeOrDeactivateRoom();
    }, 2000);
  }
}
